
import Qrcode from 'vux/src/components/qrcode/index.vue'
import Divider from 'vux/src/components/divider/index.vue'
import base64 from 'vux/src/tools/base64/index.js'

import {ParseTime} from "../../utils/time"
import {Api} from "../../utils/api"

export default {
name: 'TicketDetail',
components: {
Qrcode,
Divider
},
filters: {

},
data () {
return {
TicketID: 0,
Ticket:{},
QrValue:'',
AdminResultUrl: 'http://enroll.admin.fuyouhuiyi.com/#/scan-result'
}
},
created () {
this.TicketID = this.$route.params["ticketID"]
if (!this.TicketID) this.$router.go(-1)
this.TicketID = parseInt(this.TicketID)
this.fetchTicketDetail()
},
methods: {
ParseTime,
parseMeetingTime(str) {
let timeArr = str.split('----')
if (timeArr.length !== 2) {
return ''
}
let start = ParseTime(timeArr[0],'{y}-{m}-{d}')
let end = ParseTime(timeArr[1],'{y}-{m}-{d}')
return `${start} 至 ${end}`
},
async fetchTicketDetail() {
let res = await Api('GetTicketList',{
Data:{
ID: this.TicketID
},
Preloads:[
{Column:'Order.OrderInfo',Select:'id,meeting_head_img,sub_meeting_name,meeting_title,join_time,join_address,order_id'},
]
})
console.log(res.data.List)
if (res.data.List && res.data.List.length == 1) {
this.Ticket = res.data.List[0]
let codeStr = JSON.stringify({
Str: 'fu-you123!!!!!@#',
TicketID:this.Ticket.ID,
MeetingID: this.Ticket.MeetingID,
})
codeStr = base64.encode(codeStr)
codeStr = encodeURIComponent(codeStr)
this.QrValue = `${this.AdminResultUrl}?code=${codeStr}`
} else {
this.$vux.toast.show({
text:'获取门票信息出错',
type:'cancel',
})
this.$router.go(-1)
}
},
}
}
